import { schema } from 'normalizr';

const completedAlarm = new schema.Entity('completedAlarms', {}, { idAttribute: 'id' });
const completedAlarmsSchema = [completedAlarm];

export default completedAlarmsSchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/completedAlarmsSchema.js